import { render, staticRenderFns } from "./TabsBookings.vue?vue&type=template&id=190399ff&"
import script from "./TabsBookings.vue?vue&type=script&lang=js&"
export * from "./TabsBookings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports